module.exports = __webpack_public_path__ + "img/slider-2.d60497bf.jpg";